import { keys as parentKeys } from '@copro/api';

const all = [...parentKeys.all, 'google-drive'] as const;

export const keys = {
  all,
  config: (spaceId: string) => [...all, 'config', spaceId] as const,
};
